import { useContext } from "react";

import DataLoader from "@/components/DataLoader";
import { UserDatapointModelContent } from "@/components/UserDatapointModelContent";
import { ViewerContext } from "@/tpo/Viewer";

import {
  RESEARCH_RELATED_TO_USER_DATAPOINT_QUERY,
  USER_DATAPOINTS_QUERY,
  USER_DATAPOINT_QUERY
} from "./graphql";

export default function ModelContent({ type, item, isGenesTest }) {
  const viewerContext = useContext(ViewerContext);
  const userId = viewerContext?.userId;
  if (type === "datapoints") {
    return (
      <DataLoader
        query={USER_DATAPOINT_QUERY}
        variables={{
          userDatapointId: item.id,
          userId
        }}
        render={({ userDatapoint }) => (
          <UserDatapointModelContent
            userDatapoint={userDatapoint}
            isGenesTest={isGenesTest}
            relatedResearchQuery={RESEARCH_RELATED_TO_USER_DATAPOINT_QUERY}
            datapointGraphQuery={USER_DATAPOINTS_QUERY}
            datapointGraphSkip={false}
          />
        )}
      />
    );
  }
  return null;
}
